<kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
  [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false" [pageSize]="view.state.take"
  [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort" [filterable]="enableAdvanced"
  [filter]="view.state.filter" [groupable]="enableAdvanced" [group]="view.groups" [selectable]="{ mode: 'single' }"
  [columnMenu]="enableAdvanced" [resizable]="true" [reorderable]="enableAdvanced" (groupChange)="groupChange($event)"
  (dataStateChange)="dataStateChange($event)">
  <kendo-grid-messages noRecords="{{ 'NO-TASKS' | translate }}">
  </kendo-grid-messages>
  <kendo-grid-column field="name" [width]="40" title="{{ 'NAME' | translate }}">
    <ng-template kendoGridCellTemplate let-dataItem>
      <a class="pointer" (click)="openTask(dataItem)" title="{{dataItem.name}}">
        <strong [ngClass]="{'completed-task': dataItem.status === 'Completed'}">{{ dataItem.name }}</strong>
      </a>
    </ng-template>
  </kendo-grid-column>
  <kendo-grid-column field="dueDate" [width]="30" title="{{ 'DUE-DATE' | translate }}" filter="date" format="{0:g}">
  </kendo-grid-column>
  <kendo-grid-column field="priority" [width]="20" title="{{ 'PRIORITY' | translate }}" class="text-center">
    <ng-template kendoGridFilterCellTemplate let-filter>
      <app-dropdown-filter [filter]="filter" [data]="distinctPriorities" filterField="priority"
        selectDefaultText="{{ 'SELECT-PRIORITY' | translate }}" textField="priorityName" valueField="priority">
      </app-dropdown-filter>
    </ng-template>
    <ng-template kendoGridCellTemplate let-dataItem>
      <div [className]="dataItem.priorityBadgeClass">
        {{ dataItem.priority.charAt(0) }}</div>
      <div class="change-icon">
        <a *ngIf="dataItem.status === 'Open'" class="pointer float-right" title="{{'EDIT' | translate}}"
          (click)="openTaskPriorityDialog(dataItem);">
          <i class="fas fa-undo icon-info"></i>
        </a>
      </div>
    </ng-template>
  </kendo-grid-column>
</kendo-grid>
<button kendoButton [primary]="true" type="button" (click)="initiateTask()" class="mt-3 mr-1 float-right">
  {{'ADD-TASK' | translate}}<i class="far fa-plus"></i>
</button>
<!-- reassign task dialog -->
<app-task-priority [task]="task" [dialogOpened]="priorityDialogOpened" (closing)="closeTaskPriorityDialog();"
  (save)="updateTaskPriority($event)">
</app-task-priority>
<!--open task dialog, adjusting width to get toolbar in notes on one line -->
<div class="k-overlay" *ngIf="taskOpened"></div>
<kendo-window id="task-detail" [width]="1300" [height]="590" *ngIf="taskOpened" (close)="closeTaskDialog()"
  style="position:fixed" [top]="60" [state]="windowState">
  <kendo-window-titlebar>
    <div class="k-window-title">
      <h3 class="ellipsis-text">{{task.name}}</h3>
    </div>
    <button kendoWindowMaximizeAction></button>
    <button kendoWindowRestoreAction></button>
    <button kendoWindowCloseAction></button>
  </kendo-window-titlebar>
  <app-task-detail [task]="task" [autoComplete]="autoComplete" (completed)="onTaskCompleted()"
    (closeTaskDetail)="closeTaskDialog()" (followUpTaskAddedEvent)="getTasks()" [isDialog]="true">
  </app-task-detail>
  <kendo-dialog-actions style="position:absolute;margin-left:-16px" class="w-100 mt-3">
    <button kendoButton [primary]="true" type="button" (click)="closeTaskDialog()">
      {{ 'CLOSE' | translate}}</button>
  </kendo-dialog-actions>
</kendo-window>